import { TENNIS } from './constants';

const tournamentsIds = [
    23,
    1339,
    1462,
    1463,
    1464,
    1465,
    1466,
    1467,
    1468,
    1469,
    71473,
    10908,
    10909,
    10910,
    10911,
    10912,
    10913,
    10914,
    10915,
    10916,
    10917,
    10918,
    10919,
    10920,
    10921,
    71467,
    177,
    1820,
    9154,
    10561,
    33189,
    95265,
    142,
    6795,
    10560,
    94235,
    94237,
    94915,
    25,
    5130,
    10562,
    103568,
    104090,
    104092,
    104094,
    104096,
    104098,
    104100,
    104102,
    104104,
    104106,
];

export function decreaseOddsBy3Percent(match, bets) {
    let tournamentDesc = match.tournamentDesc.toLowerCase();

    if (tournamentsIds.includes(match.tournamentRef) || (match.sportRef === TENNIS && (tournamentDesc.includes('atp') || tournamentDesc.includes('wta')))) {
        bets.forEach(b => {
            b.eqs.forEach(o => {
                const decreaseAmount = Math.round((o.q * 3) / 100);
                o.q -= decreaseAmount;
            });
        });
    }
}
